<template>
  <List :mapState="'adminRoles'" :allDispatch="'AdminAllRoles'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/admin/roles/list.vue